import React from "react";
import { Form, Input } from "antd";

import "./FormItemInputPassword.scss";

interface FormItemInputPasswordProps {
  name: string;
  placeholder?: string;
  label: string;
  rules: { required: boolean; message?: string };
  disabled?: boolean;
  autoComplete?: string;
}
const FormItemInputPassword: React.FC<FormItemInputPasswordProps> = ({
  name,
  rules,
  placeholder,
  label,
  disabled,
  autoComplete,
}) => {
  return (
    <Form.Item
      className={`form-item__inputPassword`}
      name={name}
      label={label}
      rules={[{ required: rules.required, message: rules.message }]}
    >
      <Input.Password
        className={"input"}
        placeholder={placeholder}
        disabled={disabled}
        autoComplete={autoComplete}
      />
    </Form.Item>
  );
};

export default FormItemInputPassword;
